export default __webpack_public_path__ + "static/idris-oulmane-mri-scan-machine-4-05b07815d65ff7b71d2ebf0941a2c793.jpg";